export default {
	SET_STATE_LOGIN: (state, payload) => {
		state.stateLogin = payload;
	},
	SET_SESION_ACTIVE: (state, payload) => {
		state.isSesionActive = payload;
	},
}